module.exports = {"652302001":"博峰街","652302002":"阜新街","652302003":"准东","652302100":"甘河子镇","652302101":"城关镇","652302102":"九运街镇","652302103":"滋泥泉子镇","652302201":"上户沟哈萨克民族乡","652302202":"水磨沟乡","652302203":"三工河哈萨克民族乡","652302503":"兵团农六师土墩子农场","652302504":"兵团六运湖农场","652302505":"兵团二二二团农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652302.json
// module id = 3072
// module chunks = 0